'use client';

import { c as _c } from "react/compiler-runtime";
import { Icon, Pagination } from '@petsmart-ui/sparky';
import { useDeviceType } from '@libs/common-next';
type PageProps = {
  totalItems: number;
  currentPage: number;
  itemsPerPage?: number;
  species: string;
};
export function LearningCenterPagination(t0) {
  const $ = _c(21);
  const {
    totalItems,
    currentPage,
    itemsPerPage: t1,
    species
  } = t0;
  const itemsPerPage = t1 === undefined ? 18 : t1;
  const {
    isDesktop
  } = useDeviceType();
  const numberOfPages = Math.ceil(totalItems / itemsPerPage);
  const pagesToShow = isDesktop ? 5 : 4;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function getPaginationPages(userCurrentPage, totalPages, t3) {
      const paginationPagesToShow = t3 === undefined ? 5 : t3;
      const pages = [];
      if (totalPages <= paginationPagesToShow) {
        return Array.from({
          length: totalPages
        }, _temp);
      }
      const startPage = Math.max(1, userCurrentPage - Math.floor(paginationPagesToShow / 2));
      const endPage = Math.min(totalPages, startPage + paginationPagesToShow - 1);
      if (startPage > 1) {
        pages.push(1);
      }
      if (startPage > 2) {
        pages.push("rest");
      }
      for (let i_0 = startPage; i_0 <= endPage; i_0++) {
        pages.push(i_0);
      }
      if (endPage < totalPages - 1) {
        pages.push("rest");
      }
      if (endPage < totalPages) {
        pages.push(totalPages);
      }
      return pages;
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const getPaginationPages = t2;
  let t3;
  if ($[1] !== currentPage || $[2] !== numberOfPages || $[3] !== species) {
    t3 = numberOfPages > 1 && <Pagination.Item ariaLabel="Previous" data-testid="lc-species-pagination-previous" disabled={currentPage === 1} href={`${species}?page=${currentPage - 1}`}><span className="sparky-u-is-vishidden">Previous</span><Icon className="sparky-c-pagination__icon" name="chevron-left" /></Pagination.Item>;
    $[1] = currentPage;
    $[2] = numberOfPages;
    $[3] = species;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== currentPage || $[6] !== numberOfPages || $[7] !== pagesToShow) {
    t4 = getPaginationPages(currentPage, numberOfPages, pagesToShow);
    $[5] = currentPage;
    $[6] = numberOfPages;
    $[7] = pagesToShow;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== currentPage || $[10] !== species || $[11] !== t4) {
    t5 = t4.map(page => {
      if (page === "rest") {
        return <Pagination.Item key={page} divide={true} />;
      }
      return <Pagination.Item ariaLabel={`Page ${page}`} key={page} data-testid="lc-species-pagination-page" isActive={currentPage === page} href={`${species}?page=${page}`}>{page}</Pagination.Item>;
    });
    $[9] = currentPage;
    $[10] = species;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== currentPage || $[14] !== numberOfPages || $[15] !== species) {
    t6 = numberOfPages > 1 && <Pagination.Item ariaLabel="Next" data-testid="lc-species-pagination-next" disabled={currentPage === numberOfPages} href={`${species}?page=${currentPage + 1}`}><span className="sparky-u-is-vishidden">Next</span><Icon className="sparky-c-pagination__icon" name="chevron-right" /></Pagination.Item>;
    $[13] = currentPage;
    $[14] = numberOfPages;
    $[15] = species;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t3 || $[18] !== t5 || $[19] !== t6) {
    t7 = <Pagination removePrevButton={true} removeNextButton={true}><>{t3}{t5}{t6}</></Pagination>;
    $[17] = t3;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}
function _temp(_, i) {
  return i + 1;
}